import React, { useState, useEffect } from 'react'
import { Link, Element, Events, scrollSpy } from 'react-scroll'

import 'animate.css'
import { Row, Col } from 'antd'
import { httpClient } from 'core/util/httpClient'
import { question } from 'core/schemas'

import QuestBlog from 'components/QuestBlog'
import ScrollUpBtn from 'components/ScrollUpBtn'
import LineAnimation from 'components/LineAnimation'

import { Container, Title, TextHead, TextSection } from './questions.style'

const Questions = () => {
  const [questionData, setQuestionData] = useState({})
  const [titleList, setTitleList] = useState()

  useEffect(() => {
    window.scrollTo(0, 0)
    
    getDataQuestion()
  }, [])

  const getDataQuestion = async () => {
    const response = await httpClient.get(question)

    if (response?.data?.code === 200) {
      const data = response?.data?.data
      setQuestionData(data?.section)
      setTitleList(data)
    } else {
      setQuestionData({})
    }
  }

  const renderLink = (to, name) => {
    return (
      <Link
        activeClass='active'
        to={to}
        spy={true}
        smooth={true}
        duration={500}
        offset={-130}
      >
        <TextSection>{name}</TextSection>
      </Link>
    )
  }

  return (
    <>
      <Container>
        <Row>
          <Col span={24}>
            <Title className='animate__animated animate__flipInX animate__slow'>
              คําถามที่ถามบ่อย
            </Title>
          </Col>
        </Row>

        <Row className='row-section' gutter={[24, 24]}>
          {titleList?.section &&
            titleList?.section?.map((item) => {
              return <Col span={12}>{renderLink(item?.name, item?.name)}</Col>
            })}
        </Row>

        <div className='line-style'>
          <LineAnimation />
        </div>

        {questionData.length >= 0 &&
          questionData.map((item, index, row) => {
            return (
              <div key={`title-${index}`}>
                <Row className='row-top'>
                  <Col span={24}>
                    <Element name={item?.name} key={index}>
                      <TextHead>{item?.name}</TextHead>
                    </Element>
                  </Col>
                  <Col span={24}>
                    {item?.question.length >= 0 &&
                      item?.question.map((item, index) => {
                        return (
                          <QuestBlog
                            top='40'
                            key={`quest-${index}`}
                            headText={item?.question}
                            ansTextFirst={item?.answer_0 ? item?.answer_0 : ''}
                            ansTextSecon={item?.answer_1 ? item?.answer_1 : ''}
                            ansTextThird={item?.answer_2 ? item?.answer_2 : ''}
                          />
                        )
                      })}
                  </Col>
                </Row>
                {index + 1 !== row.length && (
                  <div className='line-style'>
                    <LineAnimation />
                  </div>
                )}
              </div>
            )
          })}
      </Container>

      <ScrollUpBtn />
    </>
  )
}

export default Questions
